import classNames from 'classnames'
import { MdDownload, MdContentCopy } from 'react-icons/md'

import type { MouseEvent, ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'

import FileLogo from '~/assets/file-icon.png'
import ActionMenu from '~/components/ActionMenu'
import { copyText } from '~/utils/navigator'

import './styles.scss'

interface PlayerProps {
  downloadUrl?: string
  fileName?: string
  mimeType?: string
}

const DisplayPlayerByMimeType = ({ downloadUrl, mimeType }: PlayerProps) => {
  /** Local state */

  const MIME_TYPE = mimeType?.split('/')[0]

  const computedDownloadUrl = `${downloadUrl}?height=155&width=244&fit=cover`

  switch (MIME_TYPE) {
    case 'audio':
      return <audio className="audio" controls data-testid="audio-player-test-id" id="audio-player" src={downloadUrl} />
    case 'image':
      return <img className="image" src={computedDownloadUrl} />
    case 'application':
      return <img className="application" src={FileLogo} />
    case 'video':
      return <video className="video" controls data-testid="video-player-test-id" src={downloadUrl} />
    default:
      return (
        <>
          <img className="application" src={FileLogo} />
          <div className="unknown">Unknown type</div>
        </>
      )
  }
}

interface Props {
  actionMenu?: Menu
  className?: string
  downloadUrl?: string
  fileId?: string
  fileName?: string
  isLoading?: boolean
  mimeType: string
}

const MediaCard = ({
  actionMenu,
  className,
  downloadUrl = '',
  fileId,
  fileName,
  isLoading,
  mimeType,
}: Props): ReactElement => {
  /** Handlers */

  const handleCopyURL = (evt: MouseEvent) => {
    evt.stopPropagation()
    copyText(downloadUrl)
  }

  const handleDownloadFile = (evt: MouseEvent) => {
    evt.stopPropagation()
    downloadUrl.length && window.open(downloadUrl, '_blank')
  }

  /** Render */

  return (
    <div className={classNames('media-card-component', className, { 'media-card-component--loading': isLoading })}>
      {isLoading ? (
        <div className="lds-dual-ring" />
      ) : (
        <>
          <div className="header">
            <div className="file-name" title={fileName}>
              <div className="text">{fileName}</div>
              {actionMenu ? <ActionMenu iconDirection="vertical" menu={actionMenu} placement="bottom" /> : null}
            </div>
            <div className="file-id" title={fileId}>
              {fileId}
            </div>
          </div>
          <div className="media">
            <DisplayPlayerByMimeType downloadUrl={downloadUrl} fileName={fileName} mimeType={mimeType} />
          </div>
          <div className="footer">
            <MdContentCopy className="action-icon" color="#ff5301" onClick={handleCopyURL} size={14} />
            <MdDownload className="action-icon" color="#ff5301" onClick={handleDownloadFile} size={14} />
          </div>
        </>
      )}
    </div>
  )
}

export default MediaCard
